import Vue from "@/libraries/vue";
import postsStore from "@/store/posts";
export default Vue.extend({
    name: "Index",
    computed: {
        storePosts: () => postsStore.posts,
        group() {
            return this.$route.params.group || "fuentes";
        },
        tag() {
            const route = this.$route;
            return route.params.tag;
        },
        posts() {
            const storePosts = this.storePosts;
            const group = this.group;
            const tag = this.tag;
            if (tag) {
                const posts = [];
                for (const g in storePosts) {
                    const gPosts = storePosts[g].filter((p) => {
                        return p.id && p.tags.includes(tag);
                    });
                    for (const post of gPosts) {
                        post.group = g;
                    }
                    posts.push(...gPosts);
                }
                return posts;
            }
            const posts = storePosts[group];
            if (!posts) {
                return [];
            }
            return posts
                .filter((p) => p.id)
                .sort((a, b) => {
                const tagsA = a.tags || [];
                const tagsB = b.tags || [];
                if (tagsA.length != tagsB.length) {
                    return tagsB.length - tagsA.length;
                }
                const audienceA = parseInt(a.audience) || 0;
                const audienceB = parseInt(b.audience) || 0;
                if (audienceA != audienceB) {
                    return audienceB - audienceA;
                }
                return (a.name || "").localeCompare(b.name || "");
            });
        },
    },
    methods: {
        postLink(post) {
            const group = post.group || this.group;
            return postsStore.postLink(post, group);
        },
    },
});
